import { render, staticRenderFns } from "./UiComponent.vue?vue&type=template&id=83df2bc2"
import script from "./UiComponent.vue?vue&type=script&lang=js"
export * from "./UiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports